import { theme } from "@local-logic/core/ui";
import { styled } from "styled-components";

export const ScoreInfo = styled.div`
  padding: ${theme["--ll-spacing-small"]} ${theme["--ll-spacing-medium"]};
  background-color: ${theme["--ll-color-surface"]};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
`;

export const ScoreContainer = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-gap: ${theme["--ll-spacing-medium"]};
  margin-bottom: ${theme["--ll-spacing-medium"]};
`;
